import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { environment } from 'src/environments/environment';
import { PayrollApiService } from './payroll-api.service';
import { lastValueFrom } from 'rxjs';
import { ResponseData } from 'src/app/helper/interface/response';
import { DataManagementService } from 'src/app/core/service/data-management.service';
import { AuthService } from 'src/app/helper/service/auth.service';
import { whereField } from '../../../helper/interface/response';

@Injectable({
  providedIn: 'root',
})
export class MasterApiService extends PayrollApiService {
  urlPayRollSeg = '/' + environment.payrollUrl;
  payrollTbl = [
    'salary_category',
    'payroll_head',
    'leave_policy',
    'leave_type',
    'hra_percentage',
    'work_from_type',
    'holiday_type',
    'experience_slot',
    'payroll_type',
    'payroll_group',
    'payroll_report_status',
    'bible_words',
    'holiday_category',
  ];
  processTbl = ['forms', 'form_category'];
  constructor(
    public override http: HttpClient,
    public override dataService: DataManagementService,
    private auth: AuthService
  ) {
    super(http, dataService);
  }
  getById(tbl: string, id: string | number): Promise<ResponseData> {
    return lastValueFrom(this.http.get(`getById/${tbl}/${id}`));
  }
  searchAgent(terms: any) {
    return lastValueFrom(this.http.get(`/search/staff/${terms}`));
  }
  getFullData(
    tbl: string,
    cond: any = '',
    isFull = false,
    lazy = {},
    forceToCall = false
  ) {
    return this.dataService.getFullData(tbl, cond, isFull, lazy, forceToCall);
  }
  saveData(tbl: string, data: any) {
    return lastValueFrom(this.http.post(`saveData/${tbl}`, data));
  }
  saveField(data: any) {
    return lastValueFrom(this.http.post(`field/save`, data));
  }
  getField(ev: any = {}) {
    return lastValueFrom(this.http.post(`field/getList`, ev));
  }
  getHomeList(ev: any = {}) {
    return lastValueFrom(this.http.post(`home/getList`, ev));
  }

  getMobileApp(ev: any = {}) {
    return lastValueFrom(this.http.post(`app/getList`, ev));
  }
  saveMobileApp(data: any = {}) {
    return lastValueFrom(this.http.post(`/app/save`, data));
  }

  getFieldByid(id: string | number, isFull = true) {
    const d = isFull ? 'true' : 'false';
    return lastValueFrom(this.http.get(`/field/get/${id}`));
  }

  getChurchReportType() {
    return lastValueFrom(this.http.get(`/churchReport/getReportType`));
  }
  getChurchByField(id: any) {
    return lastValueFrom(this.http.get(`/church/getByField/${id}`));
  }
  getPanyatAndCity(id: any) {
    return lastValueFrom(this.http.get(`/getPanchayatCity/${id}`));
  }
  getCityVillage(id: any, genderId: any) {
    return lastValueFrom(this.http.get(`/getVillageWard/${id}/${genderId}`));
  }
  generateEmail(id: string | number, data: any) {
    return lastValueFrom(this.http.post(`/genEmail/${id}`, data));
  }

  getListNotificationTemplate(type: string, ev: any) {
    ev.whereField = [{ colName: 'template_type', value: type.toLowerCase() }];
    return lastValueFrom(this.http.post(`/notification/getListTemplate`, ev));
  }
  getListNotificationConfig(ev: any) {
    return lastValueFrom(this.http.post(`/notification/getListGateway`, ev));
  }
  getNotificationGateway(id: number | string) {
    return lastValueFrom(this.http.get(`/notification/getGateway/${id}`));
  }
  saveNotificationConfig(data: any) {
    return lastValueFrom(this.http.post(`/notification/saveGateway`, data));
  }
  saveNotificationTemplate(data: any) {
    return lastValueFrom(this.http.post(`/notification/save`, data));
  }
  getNotificationById(id: string | number) {
    return lastValueFrom(this.http.get(`/notification/get/${id}`));
  }
  // notice 
  getListNotice(ev: any,type='ACTIVE') {
    return lastValueFrom(this.http.post(`/notice/getList/${type}`, ev));
  }
  deleteNotice(id) {
    return lastValueFrom(this.http.delete(`/notice/delete/${id}`));
  }
  

  getFieldByZone(id: any) {
    const data: any = Array.isArray(id) ? id.join(',') : id;
    return lastValueFrom(this.http.get(`/field/getByZone/${data}`));
  }

  exportData(tName = '', data: any = []) {
    data = JSON.stringify(data);
    return lastValueFrom(
      this.http.post(`/exportData/${tName}`, data, { responseType: 'blob' })
    );
  }
  sendEmail(data: Array<any>) {
    if (!Array.isArray(data)) {
      data = [data];
    }
    return lastValueFrom(
      this.http.post(`${environment.emailApiUrl}/sendEmail`, data)
    );
  }
  search(tbl: string, terms: any) {
    return lastValueFrom(this.http.get(`/search/${tbl}/${terms}`));
  }
  searchOfficeUser(terms: string) {
    return lastValueFrom(this.http.get(`/users/searchOfficeUser/${terms}`));
  }

  getLeaveTypeBypolicy(id: any, genderId: any) {
    return lastValueFrom(
      this.http.get(
        `${this.urlPayRollSeg}/getLeveTypeByPolicy/${id}/${genderId}`
      )
    );
  }
  getOverrideHead() {
    return lastValueFrom(
      this.http.get(`${this.urlPayRollSeg}/payrollhead/getOverrideHead`)
    );
  }

  getAllForms() {
    return lastValueFrom(
      this.http.get(`${environment.processApiUrl}/getAllForms`)
    );
  }
  getNoticeById(id: string | number) {
    return lastValueFrom(this.http.get(`notice/get/${id}`));
  }
  saveNotice(data: any) {
    return lastValueFrom(this.http.post(`notice/save`, data));
  }
  saveBibleWord(data: any) {
    return lastValueFrom(this.http.post(`bible_words/save`, data));
  }
  // deleteNotice(id: any) {
  //   return lastValueFrom(this.http.delete(`notice/${id}`));
  // }
  // deleteBibleWord(id: any) {
  //   return lastValueFrom(this.http.delete(`bible_word/${id}`));
  // }

  // home
  getHomeById(id: string | number): Promise<ResponseData> {
    return lastValueFrom(this.http.get(`/home/getById/${id}`));
  }

  //report 
  getExportModule(){
    return lastValueFrom(this.http.get(`/export/getTemplateModule`));
  }
   getReportTemplateByModule(module){
    return lastValueFrom(this.http.get(`/export/getTemplateByModule/${module}`));
  }

  // export_templates admin CRUD (create/edit/view/delete the template
  // definitions themselves - distinct from the two read-only lookups above,
  // which only let a user pick and run an already-existing template)
  getExportTemplateList(ev: any = {}) {
    return lastValueFrom(this.http.post(`/export/templateAdmin/list`, ev));
  }
  getExportTemplateById(id: string | number): Promise<ResponseData> {
    return lastValueFrom(this.http.get(`/export/templateAdmin/get/${id}`));
  }
  saveExportTemplate(data: any) {
    return lastValueFrom(this.http.post(`/export/templateAdmin/save`, data));
  }
  deleteExportTemplate(id: string | number) {
    return lastValueFrom(this.http.delete(`/export/templateAdmin/delete/${id}`));
  }
  getExportTemplateProviderOptions() {
    return lastValueFrom(this.http.get(`/export/templateAdmin/providerOptions`));
  }

  getListDcoument(ev: any = {}) {
    return lastValueFrom(this.http.post(`/document/getList`, ev));
  }
  getDocument(id) {
    return lastValueFrom(this.http.get(`/document/get/${id}`));
  }
  getDocumentByMine() {
    return lastValueFrom(this.http.get(`/document/getMine`));
  }
  saveDocument(data: any) {
    return lastValueFrom(this.http.post(`/document/save`, data));
  }
  deleteDocument(id) {
    return lastValueFrom(this.http.delete(`/document/delete/${id}`));
  }
  saveDocumentGroup(data: any) {
    return lastValueFrom(this.http.post(`/document/saveGroup`, data));
  }
  getDocumentGroupById(id) {
    return lastValueFrom(this.http.get(`/document/getGroup/${id}`));
  }
  assignStaff(data: any) {
    return lastValueFrom(this.http.post(`/home/assignStaff`, data));
  }
  // master-api.service.ts
  async getChatAiStream(
    data: any,
    onDelta: (chunk: string) => void,
    onComplete?: () => void
  ) {
    const response = await fetch(`${environment.apiUrl}/ai/stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.auth.getToken()}`,
      },
      body: JSON.stringify(data),
    });

    const reader = response.body?.getReader();
    const decoder = new TextDecoder('utf-8');

    while (true) {
      const { done, value } = await reader!.read();
      if (done) {
        if (onComplete) onComplete();
        break;
      }

      const chunk = decoder.decode(value, { stream: true });
      chunk.split('\n').forEach((line) => {
        if (line.startsWith('data: ')) {
          const payload = line.replace('data: ', '').trim();
          if (!payload || payload === '[DONE]') return;

          try {
            const json = JSON.parse(payload);
            const delta = json?.choices?.[0]?.delta?.content;
            if (delta) onDelta(delta);
          } catch (e) {
            console.warn('Invalid JSON:', payload);
          }
        }
      });
    }
  }
}
